<section class="main-section usercenter-section p-3">
    <header class="d-md-flex d-block align-items-center main-heading error-log-heading">
        <div class="d-flex align-items-center col-md-4">
            <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
                role="button" aria-controls="offcanvasExample">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </a>
            <h3 class="heading-span text-black">
                <span>System Messages</span>
            </h3>
        </div>
        <div class="d-flex col-md-8" style="text-align: right;justify-content: right;">
            <div class="d-flex ">
                <div class="input-group me-2 user-center-search mt-2 mt-md-0">
                    <span class="input-group-text bg-transparent" id="basic-addon1" (click)="getAllLogs()">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
                                stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19 19L15.71 15.71" stroke="#999999" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                    <input type="text" class="form-control usercenter-searchcontrol ps-0 bg-white" placeholder="Search"
                        aria-label="Username" aria-describedby="basic-addon1" [(ngModel)]="searchTerm"
                        (keyup.enter)="this.pageNumber = 0;this.pageOffSet = 0;getAllLogs()" />
                </div>
                <mat-icon matTooltip="{{searchBy}}" matTooltipPosition="above" class="fs-22 m-2">info</mat-icon>
            </div>

            <div class="d-flex">
                <button type="button" class="btn theme-btn px-md-5 px-2 me-0 me-sm-0 mb-0 ms-3"
                    (click)="openCreateMessage()">
                    Create Message
                </button>
            </div>
        </div>
    </header>
    <div class="tab-content">
        <div>
            <div *ngIf="systemMessages.length" class="table-responsive tab-table ticket-management-table">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="contactNumber-header">Client Reference
                                <mat-icon *ngIf="sortNameAsc"
                                    (click)="sortNameAsc=false;getAllLogs('clientReference','asc')">arrow_upward</mat-icon>
                                <mat-icon *ngIf="!sortNameAsc"
                                    (click)="sortNameAsc=true;getAllLogs('clientReference','desc')">arrow_downward</mat-icon>
                            </th>
                            <th class="contactNumber-header">Valid From
                                <mat-icon *ngIf="sortNameAsc"
                                    (click)="sortNameAsc=false;getAllLogs('validFrom','asc')">arrow_upward</mat-icon>
                                <mat-icon *ngIf="!sortNameAsc"
                                    (click)="sortNameAsc=true;getAllLogs('validFrom','desc')">arrow_downward</mat-icon>
                            </th>
                            <th class="contactNumber-header">Valid To
                                <mat-icon *ngIf="sortNameAsc"
                                    (click)="sortNameAsc=false;getAllLogs('validTo','asc')">arrow_upward</mat-icon>
                                <mat-icon *ngIf="!sortNameAsc"
                                    (click)="sortNameAsc=true;getAllLogs('validTo','desc')">arrow_downward</mat-icon>
                            </th>
                            <th class="contactNumber-header">Holding Date
                                <mat-icon *ngIf="sortNameAsc"
                                    (click)="sortNameAsc=false;getAllLogs('holdingFromDate','asc')">arrow_upward</mat-icon>
                                <mat-icon *ngIf="!sortNameAsc"
                                    (click)="sortNameAsc=true;getAllLogs('holdingFromDate','desc')">arrow_downward</mat-icon>
                            </th>
                            <th class="contactNumber-header">Message</th>
                            <th class="contactNumber-header">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let msg of systemMessages; let i = index">

                            <td>
                                <p class="mat-account-detail mat-system-messages mb-0"
                                    [matTooltip]="msg.clientReference!">
                                    {{msg.clientReference??"[Deesha]"}}
                                </p>
                            </td>
                            <td>
                                <p class="mat-account-detail mat-system-messages mb-0"
                                    [ngClass]="msg.isActive ? 'error-response':''">
                                    {{msg.validFrom | date : 'dd/MM/yyyy'}}
                                </p>
                            </td>
                            <td>
                                <p class="mat-account-detail mat-system-messages mb-0"
                                    [ngClass]="msg.isActive ? 'success-response':''">
                                    {{msg.validTo | date : 'dd/MM/yyyy'}}
                                </p>
                            </td>

                            <td>
                                <p class="mat-account-detail mat-system-messages mb-0"
                                    [ngClass]="msg.isInHolding?'success-response':''">
                                    {{msg.holdingFromDate | date : 'dd/MM/yyyy'}}
                                </p>
                            </td>
                            <td>
                                <p (click)="viewExceptionModal(msg.message!)"
                                    class="mat-account-detail read-more-detail mb-0 cursor-pointer"
                                    [matTooltip]="msg.message??''">
                                    {{msg.message}}
                                </p>
                            </td>
                            <td class="sticky-right">
                                <a (click)="preview_massage(msg.message ?? '')" class="btn-action"
                                    matTooltip="Preview message" role="button">
                                    <mat-icon>visibility</mat-icon>
                                </a>

                                <a (click)="patchForm(msg)" class="btn-action" matTooltip="Edit details"><svg width="20"
                                        height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                                            stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.90845 4.20837C10.2668 6.50837 12.1334 8.26671 14.4501 8.50004"
                                            stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M2.5 18.3334H17.5" stroke="#4F6681" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg></a>
                                &nbsp; <a (click)="showDeleteMessage(msg)" class="btn-action"
                                    matTooltip="Delete message" role="button">
                                    <mat-icon>delete</mat-icon>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator *ngIf="systemMessages.length" [length]="totalRecords" [pageSize]="pageSize"
                [pageIndex]="pageNumber" (page)="changePage($event)" [pageSizeOptions]="[10, 20, 50, 100, 500, 1000]">
            </mat-paginator>
            <div *ngIf="!systemMessages.length" class="noDataFound">
                <h1>{{'No Data Found'}}</h1>
            </div>
        </div>
    </div>

    <ng-template #systemMessageEditForm>
        <div *ngIf="showForm" [formGroup]="systemMessageForm">
            <h2 mat-dialog-title>{{this.isEdit?'Update':(this.isReadOnly?'Delete':'Create')}} Message</h2>
            <button type="button" class="btn btn-link modal-close" (click)="closeCreateForm()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg></button>
            <mat-dialog-content>
                <!-- systemMessageId -->
                <!-- clientReference -->
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <div class="mb-4">
                            <span class="black-text fs-14 mb-1">Client Reference</span>
                            <input type="text" [readonly]="isEdit||isReadOnly" [required]="false" formControlName="clientReference"
                                class="form-control"
                                [class.is-invalid]="systemMessageForm.controls['clientReference'].invalid && systemMessageForm.controls['clientReference'].touched" />
                            <div
                                *ngIf="(systemMessageForm.controls['clientReference'].invalid && systemMessageForm.controls['clientReference'].touched) || systemMessageForm.controls['clientReference'].dirty">
                                <small *ngIf="systemMessageForm.controls['clientReference'].errors?.['required']"
                                    class="text-danger fs-13">Client reference is required</small>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <div class="mb-4">
                            <span class="black-text fs-14 mb-1">Holding From</span>
                            <input type="date" [readOnly]="isReadOnly" [required]="false" formControlName="holdingFromDate" class="form-control"
                                [class.is-invalid]="systemMessageForm.controls['holdingFromDate'].invalid && systemMessageForm.controls['holdingFromDate'].touched" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <div class="mb-4">
                            <span class="black-text fs-14 mb-1">Valid From</span>
                            <input type="date"[readOnly]="isReadOnly" [required]="false" formControlName="validFrom" class="form-control"
                                [class.is-invalid]="systemMessageForm.controls['validFrom'].invalid && systemMessageForm.controls['validFrom'].touched" />

                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <div class="mb-4">
                            <span class="black-text fs-14 mb-1">Valid To</span>

                            <input type="date" [readOnly]="isReadOnly" [required]="false" formControlName="validTo" class="form-control"
                                [class.is-invalid]="systemMessageForm.controls['validTo'].invalid && systemMessageForm.controls['validTo'].touched" />

                        </div>
                    </div>
                </div>

                <div class="message">
                    <div class="col-sm-12 col-md-12">
                        <div class="mb-4">
                            <span class="black-text fs-14 mb-1">Message</span>

                            <p style="font-size: smaller;"><em>The token &#123;user&#125; will render as the user's
                                    first name.</em></p>
                            <textarea [readOnly]="isReadOnly"  type="texta" rows="4" style="width: 100%;" [required]="true"
                                formControlName="message" class="form-control"
                                [class.is-invalid]="systemMessageForm.controls['message'].invalid && systemMessageForm.controls['message'].touched">
                 </textarea>
                            <div
                                *ngIf="(systemMessageForm.controls['message'].invalid && systemMessageForm.controls['message'].touched) || systemMessageForm.controls['message'].dirty">
                                <small *ngIf="systemMessageForm.controls['message'].errors?.['required']"
                                    class="text-danger fs-13">Message is required</small>
                            </div>
                        </div>
                    </div>
                </div>

            </mat-dialog-content>
            <mat-dialog-actions>
                <div class="row">
                    <div class="col-12 text-end">
                        <button type="button" class="btn theme-btn-outline px-4"
                            (click)="closeCreateForm()">Cancel</button>

                        <button type="button" *ngIf="(systemMessageToEdit.systemMessageId!=0 && isEdit) || (systemMessageToEdit.systemMessageId==0)" class="btn theme-btn px-4 ms-3" [disabled]="systemMessageForm.invalid"
                            (click)="saveMessage()">Save</button>
                        <button type="button" *ngIf="(systemMessageToEdit.systemMessageId!=0 && !isEdit)" class="btn theme-btn px-4 ms-3" [disabled]="systemMessageForm.invalid"
                            (click)="deleteMessage(systemMessageToEdit.systemMessageId)">Delete</button>
                    </div>
                </div>
            </mat-dialog-actions>
        </div>
    </ng-template>

</section>